'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  top: 'top',
  left: 'left',
  right: 'right',
  bottom: 'bottom'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vx/axis/build/constants/orientation.js
// module id = 12
// module chunks = 0